import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { showSnackbar } from 'actions/CommonActions';
// Basic Components
import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader'
import SelectInput from 'screens/components/basic/SelectInput';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};
class POSMonerisTipDialog extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialog: true
        };
    }

    render() {
        const { t } = this.props; 
        const p = this.props;

        let tipOptions = [
            { text: t('pos.monerisTipDialog.disableTip'), value: "TF" },
            { text: t('pos.monerisTipDialog.enableAmountTip'), value: "TB" },
            { text: t('pos.monerisTipDialog.enablePercTip'), value: "TC" },
            { text: t('pos.monerisTipDialog.enableBothWaysTip'), value: "TH" },
        ]

        return (
            <div>
                <DialogInput
                    title={<DialogHeader text={t('pos.monerisTipDialog.setTip')} classicClass="posDialogClassic" />}
                    modal={true}
                    open={p.open && this.state.dialog}
                    autoScrollBodyContent={true}
                    style={{ zIndex: '950' }}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonClose"
                            className="btn-space"
                            label={t('common.close')}
                            onTouchTap={() => this.props.onClose()} />,
                        <Button
                            key={2}
                            name="addButton"
                            label={t('common.confirm')}
                            primary={true}
                            onTouchTap={() => this.props.onConfirm()} />]}
                    contentStyle={dialogStyle}>
                    <div className="row">
                        <SelectInput
                            name={p.name + "TipOption"}
                            fullWidth={true}
                            label={t('pos.monerisTipDialog.tipOption')}
                            floatingLabelText={t('pos.monerisTipDialog.tipOption')}
                            hintText={t('pos.monerisTipDialog.tipOption')}
                            defaultValue="TH"
                            options={tipOptions} />
                    </div>
                </DialogInput>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        listRecentOrders: state.entity.recentOrdersList || [],
        listOpenedOrders: state.entity.openOrdersList || [],
        branchId: state.common.branchId,
        isMedical: state.common.applicationSettings.isMedical
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showSnackbar: (message) => dispatch(showSnackbar(message)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSMonerisTipDialog))